// extracted by mini-css-extract-plugin
export default {"productGrid":"zca-z","centerLink":"Aca-z","productSection":"Bca-z","item":"Cca-z","ctaButton":"Dca-z"};